"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUCCESS_TYPE = exports.default = void 0;
var _default = {
  REQUEST_CHANGES: 'Thanks! Your requested changes have been submitted. If we need more information we will contact you directly. You will be notified by email when your video is ready to review.',
  ADMIN_REQUEST_CHANGES: 'Thanks! Your requested changes have been submitted. You will be notified by email when your video is ready to review.',
  BRIEF_SUBMITTED: 'Great! Your video has been submitted for editing. If we need more information we will contact you directly. You will be notified by email when your video is ready to review.',
  APPROVAL_REQUESTED: "Great! We've sent an email to the people who can approve your video - you don't need to do anything else. If you want to send them another notification, come back later and click 'Request Approval' again."
};
exports.default = _default;
var SUCCESS_TYPE = {
  REQUEST_CHANGES: 'REQUEST_CHANGES',
  ADMIN_REQUEST_CHANGES: 'ADMIN_REQUEST_CHANGES',
  BRIEF_SUBMITTED: 'BRIEF_SUBMITTED',
  APPROVAL_REQUESTED: 'APPROVAL_REQUESTED'
};
exports.SUCCESS_TYPE = SUCCESS_TYPE;